<template>
  <Modal 
    :large="true"
    :exit="false"
  >
    <div slot="header">
      <div class="__form">
        <form>
          <div class="__header l-mb-3 l-pb-3">
            <h2 class>
              Informatie over deze woning?
            </h2>
            <h3> Naar welke informatie ben je op zoek? </h3>
          </div>
          <div class="flex-row">
            <div class="flex-row-item">
              <div class="form-group form-group-inline">
                <h3 class="form-label">
                  Kenmerken van {{ stadJson.street }} {{ stadJson.number }}
                </h3>
                <div class="switch-wrapper">
                  <input
                    id="woningKenmerk"
                    v-model="informatieVerzoek.woningKenmerk"
                    type="checkbox"
                    class="switch"
                  >
                  <label for="woningKenmerk" />
                </div>
              </div>

              <!-- /// WONING KENMERKGEN DETAILS -->
              <div v-if="informatieVerzoek.woningKenmerk" class="l-mb-6 l-ml-1 l-mr-6">
                <p v-if="basicStreetData" class="l-mb-4">
                  {{ basicStreetData }}
                </p>
                <p v-else>
                  <Spinner />
                </p>
                <div class="flex-row">
                  <legend>
                    Straat naam
                  </legend>
                  <div class="switch-wrapper">
                    {{ stadJson.street }}
                  </div>
                </div>
                <div class="flex-row">
                  <legend>
                    Stad
                  </legend>
                  <div class="switch-wrapper">
                    {{ stadJson.city }}
                  </div>
                </div>
                <div class="flex-row">
                  <legend>
                    Postcode
                  </legend>
                  <div class="switch-wrapper">
                    {{ stadJson.postcode }}
                  </div>
                </div>
                <div class="flex-row">
                  <legend>
                    Huisnummer
                  </legend>
                  <div class="switch-wrapper">
                    {{ stadJson.number }}
                  </div>
                </div>
                <div class="flex-row">
                  <legend>
                    Huisnummer toevoeging
                  </legend>
                  <div class="switch-wrapper">
                    {{ stadJson.numberAddition || "n/a" }}
                  </div>
                </div>
                <div class="flex-row">
                  <legend>
                    Bouwjaar
                  </legend>
                  <div class="switch-wrapper">
                    {{ stadJson.bouwjaar || "geen informatie" }}
                  </div>
                </div>
                <div class="flex-row">
                  <legend>
                    Type woning
                  </legend>
                  <div class="switch-wrapper">
                    {{ stadJson.woningType || "geen informatie" }}
                  </div>
                </div>
              </div>

              <!-- /// WAARDE KENMERKGEN SELECTOR -->
              <div v-if="stadJson.propertyValueMin" class="form-group form-group-inline">
                <h3 class="form-label">
                  Woningwaarde {{ stadJson.street }} {{ stadJson.number }}{{ stadJson.numberAddition || "" }}
                </h3>
                <div class="switch-wrapper">
                  <input
                    id="woningWaarde"
                    v-model="informatieVerzoek.woningWaarde"
                    type="checkbox"
                    class="switch"
                  >
                  <label for="woningWaarde" />
                </div>
              </div>

              <!-- // WAARDE KENMERKGEN DETAILS  -->
              <div v-if="informatieVerzoek.woningWaarde && stadJson.propertyValueMin" class="l-mb-6 l-ml-1 l-mr-6">
                <p class="l-mb-2">
                  Voor deze woning aan de {{ stadJson.street }} hebben we een modelwaarde bepaald op basis van de beschikbare kenmerken, onder andere de gemiddelde prijs per vierkante meter in de {{ stadJson.street }}.
                </p>
                <div v-if="stadJson.propertySize" class="flex-row">
                  <legend>
                    Woning omvang
                  </legend>
                  <div class="switch-wrapper">
                    {{ stadJson.propertySize }}
                  </div>
                </div>
                <div v-if="stadJson.propertyValueMin" class="flex-row">
                  <legend>
                    Ondergrens woningwaarde
                  </legend>
                  <div class="switch-wrapper">
                    {{ stadJson.propertyValueMin }}
                  </div>
                </div>
                <div v-if="stadJson.propertyValueMax" class="flex-row">
                  <legend>
                    Bovengrens woningwaarde
                  </legend>
                  <div class="switch-wrapper">
                    {{ stadJson.propertyValueMax }}
                  </div>
                </div>
                <!-- <div class="flex-row">
                  <legend>
                    iSalu woningwaarde inschatting
                  </legend>
                  <div class="switch-wrapper">
                    {{ selectpropertyValueAvg }}
                  </div>
                </div>
                <div class="flex-row">
                  <legend>
                    Bovengrens woningwaarde
                  </legend>
                  <div class="switch-wrapper">
                    {{ selectpropertyValueAvgMeter }}
                  </div>
                </div> -->
              </div>

              <!-- /// ENERGYLABEL SELECTOR -->
              <div v-if="stadJson.propertyEnergylabel" class="form-group form-group-inline">
                <h3 class="form-label">
                  Energylabel {{ stadJson.street }} {{ stadJson.number }}{{ stadJson.numberAddition || "" }}
                </h3>
                <div class="switch-wrapper">
                  <input
                    id="energyLabel"
                    v-model="informatieVerzoek.energyLabel"
                    type="checkbox"
                    class="switch"
                  >
                  <label for="energyLabel" />
                </div>
              </div>

              <!-- // ENERGYLABEL DETAILS  -->
              <div v-if="informatieVerzoek.energyLabel && stadJson.propertyEnergylabel" class="l-mb-6 l-ml-1 l-mr-6">
                <p class="l-mb-2">
                  Voor deze woning aan de {{ stadJson.street }} is het energyLabel {{ stadJson.propertyEnergylabel }} geregisteerd.
                </p>
                <div class="flex-row">
                  <legend>
                    EnergyLabel
                  </legend>
                  <div class="switch-wrapper">
                    {{ stadJson.propertyEnergylabel }}
                  </div>
                </div>
                <!-- <div class="flex-row">
                  <legend>
                    EnergyLabel geldig tot
                  </legend>
                  <div class="switch-wrapper">
                    {{ selectpropertyenergyLabelValidUntil }}
                  </div>
                </div> -->
              </div>

              <!-- /// STAD KENMERKEN SELECTOR -->
              <div v-if="stadJson.provincy" class="form-group form-group-inline">
                <h3 class="form-label">
                  Kenmerken van {{ stadJson.city }}
                </h3>
                <div class="switch-wrapper">
                  <input
                    id="woningStad"
                    v-model="informatieVerzoek.woningStad"
                    type="checkbox"
                    class="switch"
                  >
                  <label for="woningStad" />
                </div>
              </div>

              <!-- // STAD KENMERKGEN DETAILS -->
              <div v-if="informatieVerzoek.woningStad && stadJson.provincy" class="l-mb-6 l-ml-1 l-mr-6">
                <p  v-if="basicCityData" class="l-mb-4">
                  {{ basicCityData }}
                </p>
                <p v-else>
                  <Spinner />
                </p>
                <div class="flex-row">
                  <legend>
                    Gemeente
                  </legend>
                  <div class="switch-wrapper">
                    {{ stadJson.gemeenteNaam || "geen informatie" }}
                  </div>
                </div>
                <div class="flex-row">
                  <legend>
                    Provincie
                  </legend>
                  <div class="switch-wrapper">
                    {{ stadJson.provincy || "geen informatie" }}
                  </div>
                </div>
                <div class="flex-row">
                  <legend>
                    Provincie afkorting
                  </legend>
                  <div class="switch-wrapper">
                    {{ stadJson.provincyAfkorting || "geen informatie" }}
                  </div>
                </div>
              </div>

              <!-- /// Overig selector -->
              <div v-if="stadJson.provincy" class="form-group form-group-inline">
                <h3 class="form-label">
                  Ik zoek iets anders
                </h3>
                <div class="switch-wrapper">
                  <input
                    id="anders"
                    v-model="informatieVerzoek.anders"
                    type="checkbox"
                    class="switch"
                  >
                  <label for="anders" />
                </div>
              </div>

              <!-- // Overig DETAILS -->
              <div v-if="informatieVerzoek.anders" class="l-mb-6 l-ml-1 l-mr-6">
                <p  class="l-mb-4">
                  Laat ons weten wat je zoekt. We gaan ons best doen om dit zo spoedig mogelijk voor iedereen toe te voegen.
                </p>
              <Contact />
              </div>

            </div> 
          </div>
        </form>
      </div>
    </div>
    <div slot="footer">
      <div class="flex-row">
        <legend>
          Om deze service GRATIS te kunnen blijven aanbieden openen we de pagina van een van onze partners.
        </legend>
        <a
          type="submit"
          class="btn-blue"
          @click.stop.prevent="submit"
        >
          Bedankt
        </a>
      </div>
    </div>
  </Modal>
</template>
<script>
import { mapState } from "vuex";
import Modal from "@/components/ComponentModal";
import Contact from "@/components/ComponentContact";
import Spinner from "@/components/Spinner";
import axios from 'axios';

export default {
  name: "Dialog",
  components: {
    Modal,
    Contact,
    Spinner
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    stadJson: {
      type: Object,
      required: false
    },
    starter: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      step: 1,
      informatieVerzoek: {
        woningKenmerk: false,
        woningPrijs: false,
        woningOverig: false,
        submitted: false,
        woningStraat: false,
        woningStad: false,
        woningWaarde: false,
        energyLabel: false,
        anders: false
      },
      basicStreetData: null,
      basicCityData: null,
      options: ['Waarde woning', 'overig'],
    };
  },
  computed: {
    ...mapState({
      stateModal: state => state.openModal,
    })
  },
  mounted() {
    this.waitForLCP();
  },
  methods: {
    submit() {
      this.submitted = true;
      this.$store.dispatch("toggleModal", !this.stateModal);
      window.open('https://tc.tradetracker.net/?c=34975&m=2091628&a=480276&r=&u=', '_blank', 'width=800,height=600');
    },
    waitForLCP() {
      // Controleer eerst of PerformanceObserver beschikbaar is in de browser
      if ('PerformanceObserver' in window && 'largestContentfulPaint' in window.PerformanceObserver.supportedEntryTypes) {
        const observer = new PerformanceObserver((entryList) => {
          const entries = entryList.getEntries();
          // LCP bereikt, trigger Vue.js-code
          if (entries.length > 0 && entries[entries.length - 1].entryType === 'largestContentfulPaint') {
            this.executeAfterLCP();
            observer.disconnect();  // Stop met het observeren zodra LCP is bereikt
          }
        });

        // Begin met het observeren van de LCP-gebeurtenis
        observer.observe({ type: 'largest-contentful-paint', buffered: true });
      } else {
        // Als PerformanceObserver niet beschikbaar is, voer dan de code onmiddellijk uit
        this.fetchData();
      }
    },
    async fetchData() {
      this.loading = true; // Zet de loading status aan
      this.error = null;   // Reset eventuele eerdere fouten

      axios.defaults.headers.common['x-api-key'] = process.env.VUE_APP_GATEWAY_API;
      axios.defaults.responseType = 'json';

      const params = {
        provincie: this.stadJson.provincy.charAt(0).toUpperCase() + this.stadJson.provincy.slice(1),
        stad: this.stadJson.city.charAt(0).toUpperCase() + this.stadJson.city.slice(1),
        straat: this.stadJson.street.charAt(0).toUpperCase() + this.stadJson.street.slice(1),
      };

      try {
        // Maak de API-aanroep
        const response = await axios.get('https://0ovja4ep62.execute-api.eu-west-2.amazonaws.com/' + process.env.NODE_ENV + '/stadStraat', {params});
        
        // Sla de opgehaalde data op in de component state
        this.basicStreetData = response.data['body-json'].body.parsedStraatData.straatBeschrijving;
        this.basicCityData = response.data['body-json'].body.parsedStadData.stadBeschrijving;
        
      } catch (err) {
        // In geval van een fout, sla de fout op
        this.error = 'Er is een fout opgetreden bij het ophalen van de data.';
      } finally {
        this.loading = false;
      }
    }
  },
};
</script>

<style>
.__header {
  border-bottom: 1px solid #e7e7e7;
}
.form-label {
  font-weight: 400;
  font-size: 16px;
}
.selector {
  width: 50%;
  font-weight: 400;
  font-size: 16px;
}

@media screen and (min-width: 768px) {
  .__form {
    margin: 14px 0;
    padding: 20px 40px;
  }
  .__image img {
    max-width: 300px;
    margin-left: auto;
    height: auto;
  }
  .form-label {
    font-weight: 600;
    font-size: 20px;
  }
}

.flex-row-item {
  flex: 1 1 auto;
}

@media (min-width: 820px) {
  .form-input--small {
    width: 50%;
  }

}

</style>
